import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=5b6b0408&"
import script from "./Commission.vue?vue&type=script&lang=ts&"
export * from "./Commission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports